import { NavLink, useParams } from 'react-router-dom'
import CustomCard from '../../components/CustomCard.tsx'
import { useEffect } from 'react'
import { protectedResources } from '../../global/config.tsx'
import { clearSelectedEvent, fetchEventFromApiData } from '../../redux/eventSlice.tsx'
import { useOidcAccessToken, useOidcUser } from '@axa-fr/react-oidc'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks.tsx'
import styles from '../../styles/components/eventDetail.module.scss'
import IconText from '../../components/IconText.tsx'
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Toolbar } from '@syncfusion/ej2-react-grids'
import { fetchDataFromApi } from '../../services/fetchDataFromApi.tsx'
import { createSpinner, hideSpinner, showSpinner } from '@syncfusion/ej2-react-popups'
import { OidcUserExtendedInfo } from '../../types/OidcUserExtendedInfo.tsx'
import { MenuHeaderBar } from '../../components/global/MenuHeaderBar.tsx'
import { SelectEventArgs, TabComponent } from '@syncfusion/ej2-react-navigations'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'

// type FormDataVerguetung = {
//   acceptAgb: boolean
// }

// type FormDataTech = {
//   overheadProjector: boolean
//   laptop: boolean
//   videoCamera: boolean
//   flipchartCount: 0
//   moderationCase: 0
//   pinnwand: 0
// }

const EventDetails = () => {
  const { eventId } = useParams()
  const { accessToken } = useOidcAccessToken()
  const dispatch = useAppDispatch()
  const selectedDocentId = useAppSelector((state) => state.app.selectedDocIdx)

  const eventData = useAppSelector((state) => state.event.selectedEvent)
  // const { control: controlContract, handleSubmit: handleSubmitContract } = useForm<FormDataVerguetung>()
  // const { control: controlTech, handleSubmit: handleSubmitTech } = useForm<FormDataTech>()

  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()


  useEffect(() => {
    if (oidcUser && accessToken && selectedDocentId) {
      const url = `${protectedResources.apiList.readEvent}/${selectedDocentId}/${eventId}`
      dispatch(fetchEventFromApiData({ url: url, token: accessToken }))
    }
  }, [accessToken, oidcUser])

  useEffect(() => {
    if (import.meta.env.DEV) console.log(eventData)
  }, [eventData])

  // const docGridDummyData = [
  //   {
  //     filename: 'LoremIpsum.pdf',
  //     note: 'Ergänzung',
  //     vorderva: 0,
  //     nachderva: 1,
  //     public: 0,
  //   },
  //   {
  //     filename: 'LoremIpsum.pdf',
  //     note: 'Ergänzung',
  //     vorderva: 0,
  //     nachderva: 1,
  //     public: 0,
  //   },
  // ]

  // const dummyBestuhlungsart = ['Parlamentarisch', 'Zweite Option']

  // const docGridPublicTpl = () => {
  //   return <CheckBoxComponent />
  // }

  // const docGridDownloadTpl = () => {
  //   return <ButtonComponent type="button" className="e-link" iconCss="e-icons e-download"></ButtonComponent>
  // }

  // Teilnehmer Grid Anwesenheit Checkbox
  // const tlnGridCbTpl = (props: any) => {
  //   return (
  //     <CheckBoxComponent
  //       onChange={() => {
  //         if (import.meta.env.DEV) console.log(props.id)
  //         // update entry api call
  //       }}
  //     />
  //   )
  // }

  //   const onSubmitVerguetung: SubmitHandler<FormDataVerguetung> = (formData) => {
  //     console.log(formData)
  //   }

  // const onSubmitTech: SubmitHandler<FormDataTech> = (formData) => {
  //   if (import.meta.env.DEV) console.log(formData)
  // }

  useEffect(() => {
    dispatch(clearSelectedEvent())

    const html = document.getElementById('root')
    if (html instanceof HTMLElement) {
      createSpinner({
        target: html,
      })
    }
  }, [dispatch])

  // Download Teilnehmer Liste
  const handleClickDlPartList = () => {
    const html = document.getElementById('root')
    const url = `${protectedResources.apiList.readEventParticipants}/${selectedDocentId}/${eventId}`
    if (html instanceof HTMLElement) showSpinner(html)
    const timeout = setTimeout(() => {
      if (accessToken) {
        fetchDataFromApi(url, accessToken, 'GET', 'blob').then((response) => {
          const href = URL.createObjectURL(response.data)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute('download', `Teilnehmerliste_${eventId}.pdf`) //or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
          if (html instanceof HTMLElement) {
            hideSpinner(html)
          }
        })
      }
    }, 2000)
    return () => {
      clearTimeout(timeout)
    }
  }

  // const handleClickNewDoc = () => {
  //   dlgUploadDoc.current?.show()
  // }

  const backToOverviewBtn = () => {
    return (
      <NavLink className="e-btn e-control e-primary" to="/seminare">
        <span className="e-btn-icon e-icons e-chevron-left-3 e-icon-left"></span>
        Zur Übersicht
      </NavLink>
    )
  }

  //const bestuhlung: string[] = ['parlamentarisch', 'U-Form', 'Stuhlkreis', 'siehe Bemerkungen']

  const handleTabSelection = (e: SelectEventArgs) => {
    console.log(e)
  }


  // Download Teilnehmerlsite Button in Grid Toolbar
  const participantsToolbar = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px', borderTop: '1px solid #e0e0e0' }}>
        <ButtonComponent onClick={handleClickDlPartList} iconCss="e-icons e-download" cssClass="e-flat" content="Teilnehmerliste" disabled={!eventData?.participants || eventData.participants.length === 0}></ButtonComponent>
      </div>
    )
  }

  return (
    <>
      <MenuHeaderBar headerContent={'Veranstaltungsdetails'} contentRight={backToOverviewBtn}></MenuHeaderBar>
      <div className={`nw-content ${styles.eventDetail}`}>
        <div className={styles.smallScreen}>
          <div>
            <CustomCard header={eventData?.eventTitle} headerBadgeContent={eventData?.eventIsInhouse ? 'InHouse' : ''}>
              <p className={styles.subline}>{eventData?.eventDescription}</p>
              <div className={styles.eventInfoGrid}>
                <IconText icon="e-date-time" label="Datum und Uhrzeit" value={eventData?.dates} />
                {eventData?.eventProdTyp === 'Online' ? (
                  <IconText icon="e-location" label="Ort" value={`${eventData?.location.city}`} />
                ) : (
                  <IconText icon="e-location" label="Ort" value={`${eventData?.location.name ?? ''}, ${eventData?.location.postcode ?? ''} ${eventData?.location.city ?? ''}${eventData?.location.street ? `, ${eventData.location.street}` : ''}`} />
                )}
                <IconText icon="e-bookmark" label="VA-Nr." value={eventData?.eventCode} />
                <IconText icon="e-more-vertical-4" label="Status" value={eventData?.eventStatus} />
                <IconText icon="e-link" label="Typ" value={eventData?.eventProdTyp} />
                <IconText icon="e-people" label="Anmeldungen" value={eventData?.eventActParticipant} />
              </div>
            </CustomCard>
          </div>

          {(eventData?.eventStatus === 'Aktiv' || eventData?.eventStatus === 'Wahrscheinlich') && (
            <CustomCard style={{ height: '100%', minHeight: '400px' }} header={'Details'}>
              <TabComponent
                heightAdjustMode={'Fill'}
                selected={(e: SelectEventArgs) => {
                  handleTabSelection(e)
                }}
              >
                <div className="e-tab-header">
                  <div> Teilnehmer</div>
                  <div> Raumausstattung / Technikbestellung</div>
                  <div> Dokumente</div>
                  <div> Fahrkarte</div>
                </div>
                <div className="e-content">
                  <div style={{ height: 'calc(100%- 43px)' }}>
                    <GridComponent dataSource={eventData?.participants} height={'100%'} enableAdaptiveUI={true} toolbarTemplate={participantsToolbar}>
                      <ColumnsDirective>
                        <ColumnDirective visible={false} field="participantId" headerText="ID" />
                        {!eventData?.eventIsInhouse && <ColumnDirective field="registrationDate" headerText="Anmeldung" type="date" format="dd.MM.yyyy" width={'150px'} />}
                        <ColumnDirective field="authorityName" headerText="Verwaltung" width={'40%'} />
                        <ColumnDirective field="state" headerText="Bundesland" />
                        <ColumnDirective field="fullName" headerText="Name" />
                        <ColumnDirective field="activity" headerText="Tätigkeit" />
                        {!eventData?.eventIsInhouse && <ColumnDirective field="participantType" headerText="Teilnahme" width={'100px'} />}
                        {/* <ColumnDirective headerText="Anwesenheit" template={tlnGridCbTpl} textAlign="Center" /> */}
                      </ColumnsDirective>
                      <Inject services={[Toolbar]} />
                    </GridComponent>
                  </div>
                  <div style={{ height: 'calc(100% - 63px)' }}>
                    <div style={{ margin: '20px' }}>
                      <h3>Technik</h3>
                      <br />
                      <p>
                        Bitte nutzen Sie den <a href={`https://www.kbw.de/formulare/technikbestellung/order.php?Code=${eventData?.eventCode}&Name=${oidcUser.name}`}>Link</a> + "für eine Technikbestellung
                        <br />
                        Wir arbeiten an einer integrierten Bestellmöglichkeit.
                      </p>
                    </div>
                  </div>
                  <div style={{ height: 'calc(100% - 63px)' }}>
                    <div style={{ margin: '20px' }}>
                      <h3>Dokumente</h3>

                      {/*<UploadComponent buttonList={{ browse: 'Datei auswählen', upload: 'Hochladen', clear: 'Löschen' }} />*/}
                      <p>
                        Bitte nutzen Sie den <a href="https://austausch.kbw.de/">Link</a> " + "für den Dokumentenaustausch.
                        <br />
                        Wir arbeiten an einer integrierten Dokumentenverwaltung.
                      </p>
                    </div>
                  </div>
                  <div style={{ height: 'calc(100% - 63px)' }}>
                    <div style={{ margin: '20px' }}>
                      <h3>Fahrkarten</h3>
                      <br />
                      <p>
                        Bitte nutzen Sie den <a href={`https://www.kbw.de/bahn/order.php?Code=${eventData?.eventCode}&Name=${oidcUser.name}`}>Link</a> " + "für eine Fahrkartenbestellung.
                        <br />
                        Wir arbeiten an einer integrierten Reisekostenverwaltung.
                      </p>
                    </div>
                  </div>
                </div>
              </TabComponent>
            </CustomCard>
          )}

          {/* <CustomCard header="Dokumentenvorlagen für Ihre Präsentation">
        <DocTemplateFiles eventId={eventData?.eventId} />
      </CustomCard> */}

          {/* <CustomCard header="Seminar - Dokumente" headerBtnLabel="Neu" headerBtnIcon="e-plus" headerBtnAction={handleClickNewDoc}>
        <GridComponent dataSource={docGridDummyData}>
          <ColumnsDirective>
            <ColumnDirective field="filename" headerText="Dateiname" />
            <ColumnDirective field="note" headerText="Bemerkungen" />
            <ColumnDirective field="vorderva" headerText="vor der VA" />
            <ColumnDirective field="nachderva" headerText="nach der VA" />
            <ColumnDirective field="public" headerText="Public" template={docGridPublicTpl} textAlign="Center" />
            <ColumnDirective headerText="Download" template={docGridDownloadTpl} textAlign="Center" />
          </ColumnsDirective>
        </GridComponent>
      </CustomCard> */}

          {/* <CustomCard header="Technik">
        <p className={styles.text}>Unsere Räume sind alle mit einem Beamer mit der Auflösung 1024x1080 und WLAN ausgestattet. Zusätzlich können Sie folgende Technik für das Seminar buchen:</p>
        <form onSubmit={handleSubmitTech(onSubmitTech)}>
          <div className={styles.flexCols}>
            <div className={styles.checkboxWrapper}>
              <Controller control={controlTech} name="overheadProjector" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Overhead-Projektor" checked={field.value} change={(e: CheckBoxChangeEventArgs) => field.onChange(e.checked)} />} />
              <Controller control={controlTech} name="laptop" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Laptop" checked={field.value} change={(e: CheckBoxChangeEventArgs) => field.onChange(e.checked)} />} />
              <Controller control={controlTech} name="videoCamera" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Videokamera" checked={field.value} change={(e: CheckBoxChangeEventArgs) => field.onChange(e.checked)} />} />
            </div>
            <div>
              <div>
                <span>Flipchart</span>
                <NumericTextBoxComponent value={0} format="###.##" min={0} />
              </div>
              <div>
                <span>Moderationskoffer</span>
                <NumericTextBoxComponent value={0} format="###.##" min={0} />
              </div>
              <div>
                <span>Pinnwand</span>
                <NumericTextBoxComponent value={0} format="###.##" min={0} />
              </div>
            </div>
            <div>
              <span>Bestuhlungsform</span>
              <DropDownListComponent dataSource={dummyBestuhlungsart} value="Parlamentarisch" />
            </div>
          </div>
          <div className={styles.flexRight}>
            <ButtonComponent isPrimary>Speichern</ButtonComponent>
          </div>
        </form>
      </CustomCard> */}

          {/* <DialogComponent ref={dlgUploadDoc} width="450px" minHeight="350px" header="Dokumente hochladen" isModal={true} visible={false} showCloseIcon={false} closeOnEscape={false} footerTemplate={footerTemplate}>
        <DlgUploadDoc />
      </DialogComponent> */}
        </div>
      </div>
    </>
  )
}

export default EventDetails
